import { TransferState, inject } from "@angular/core";
import { UrlModel } from "@shared/model/urlModels/url-model";
import { BookModel } from "@shared/model/bookModels/book-model";
import { IPostModel } from "@app/pages/posts/models/post.model";
import { TServiceResult } from "@shared/helper/t-service-result";
import { LocalRepository } from "@shared/helper/local-repository";
import { QuoteModel } from "@app/pages/quotes/models/quote-model";
import { ResolveFn } from "@angular/router";
import { PageList } from "@shared/model/categoryAndSearch/pageList-model";
import { ReviewAggrigatorModel } from "@shared/model/review-aggrigator-model";
import { BookGenreSettingModel } from "@app/pages/genres/model/book-genre-model";
import { ActivitiesAggrigatorModel } from "@shared/model/activities-aggrigator-model";
import { IClubCourseAggregateModel } from "@app/pages/clubs/models/club-course-aggregate-model";
import { BooklistAggrigatorModel } from "@app/pages/booklists/models/booklist-aggrigator-model";
import { BookDetailsFacadeService, STATE_KEY_BOOK } from "@shared/service/http_services/facades/book.details.facade.service";


export const BookDetailResolver: ResolveFn<BookResolverData> = (route) => {
    const serverState: TransferState = inject(TransferState);
    const facade: BookDetailsFacadeService = inject(BookDetailsFacadeService);
    const _localRepository: LocalRepository = inject(LocalRepository);
    if (!_localRepository.IsInBrowser) {
        return facade.resolveBookDetail(route.paramMap.get('id')!);
    }
    else {
        return serverState.get(STATE_KEY_BOOK, BookResolverData.instanceAllError())
    }
}

export class BookResolverData {
    book!: TServiceResult<BookModel>;
    posts!: TServiceResult<PageList<IPostModel>>;
    shopLinks!: TServiceResult<PageList<UrlModel>>;
    bookLists!: TServiceResult<PageList<BooklistAggrigatorModel>>;
    otherReviews!: TServiceResult<PageList<ReviewAggrigatorModel>>;
    myReview!: TServiceResult<ReviewAggrigatorModel>;
    userActivities!: TServiceResult<PageList<ActivitiesAggrigatorModel>>;
    genres!: TServiceResult<PageList<BookGenreSettingModel>>;
    quotes!: TServiceResult<PageList<QuoteModel>>
    clubs!: TServiceResult<PageList<IClubCourseAggregateModel>>
    workBooks!: TServiceResult<PageList<BookModel>>

    get hasBook(): boolean { return this.book?.hasError == false };
    get hasPosts(): boolean { return this.posts?.hasError == false };
    get hasShopLinks(): boolean { return this.shopLinks?.hasError == false };
    get hasBookLists(): boolean { return this.bookLists?.hasError == false };
    get hasOtherReviews(): boolean { return this.otherReviews?.hasError == false };
    get hasActivity(): boolean { return this.userActivities?.hasError == false };
    get hasGenre(): boolean { return this.genres?.hasError == false };
    get hasMyReview(): boolean { return this.myReview?.hasError == false };
    get hasQuote(): boolean { return this.quotes?.hasError == false };
    get hasClub(): boolean { return this.clubs?.hasError == false };
    get hasWorkBook(): boolean { return this.quotes?.hasError == false };

    public static instance(brd: any): BookResolverData {
        const data = new BookResolverData();
        data.book = brd.book?.hasError == true ? new TServiceResult<BookModel>(new BookModel(), '', null, true, '') : brd.book;
        data.posts = brd.posts?.hasError == true ? new TServiceResult<PageList<IPostModel>>(new PageList(), '', null, true, '') : brd.posts;
        data.shopLinks = brd.shopLinks?.hasError == true ? new TServiceResult<PageList<UrlModel>>(new PageList(), '', null, true, '') : brd.shopLinks;
        data.bookLists = brd.bookLists?.hasError == true ? new TServiceResult<PageList<BooklistAggrigatorModel>>(new PageList(), '', null, true, '') : brd.bookLists;
        data.otherReviews = brd.otherReviews?.hasError == true ? new TServiceResult<PageList<ReviewAggrigatorModel>>(new PageList(), '', null, true, '') : brd.otherReviews;
        data.myReview = brd.myReview?.hasError == true ? new TServiceResult<ReviewAggrigatorModel>(new ReviewAggrigatorModel(), '', null, true, '') : brd.myReview;
        data.userActivities = brd.userActivities?.hasError == true ? new TServiceResult<PageList<ActivitiesAggrigatorModel>>(new PageList(), '', null, true, '') : brd.userActivities;
        data.genres = brd.genres?.hasError == true ? new TServiceResult<PageList<BookGenreSettingModel>>(new PageList(), '', null, true, '') : brd.genres;
        data.quotes = brd.quotes?.hasError == true ? new TServiceResult<PageList<QuoteModel>>(new PageList(), '', null, true, '') : brd.quotes;
        data.clubs = brd.clubs?.hasError == true ? new TServiceResult<PageList<IClubCourseAggregateModel>>(new PageList(), '', null, true, '') : brd.clubs;
        data.workBooks = brd.hasWorkBook?.hasError == true ? new TServiceResult<PageList<BookModel>>(new PageList(), '', null, true, '') : brd.workBooks;
        return data;
    }

    public static instanceAllError(): BookResolverData {
        const data = new BookResolverData();
        data.posts = new TServiceResult<PageList<IPostModel>>(new PageList(), '', null, true, '');
        data.shopLinks = new TServiceResult<PageList<UrlModel>>(new PageList(), '', null, true, '');
        data.bookLists = new TServiceResult<PageList<BooklistAggrigatorModel>>(new PageList(), '', null, true, '');
        data.book = new TServiceResult<BookModel>(new BookModel(), '', null, true, '');
        data.otherReviews = new TServiceResult<PageList<ReviewAggrigatorModel>>(new PageList(), '', null, true, '');
        data.myReview = new TServiceResult<ReviewAggrigatorModel>(new ReviewAggrigatorModel(), '', null, true, '');
        data.userActivities = new TServiceResult<PageList<ActivitiesAggrigatorModel>>(new PageList(), '', null, true, '');
        data.genres = new TServiceResult<PageList<BookGenreSettingModel>>(new PageList(), '', null, true, '');
        data.quotes = new TServiceResult<PageList<QuoteModel>>(new PageList(), '', null, true, '');
        data.clubs = new TServiceResult<PageList<IClubCourseAggregateModel>>(new PageList(), '', null, true, '');
        data.workBooks = new TServiceResult<PageList<BookModel>>(new PageList(), '', null, true, '');
        return data;
    }
}
